const glassWallPartTypes = {
  door: 'door',
  glass: 'glass',
};

export default glassWallPartTypes;
